var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_11412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.55 44.7829V55.4448C58.55 57.5928 56.8112 59.3502 54.6426 59.3502H24.4575C22.3084 59.3502 20.55 57.6123 20.55 55.4448V25.2557C20.55 23.1077 22.2889 21.3502 24.4575 21.3502H35.1249",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7109 25.0985C54.2944 25.0985 54.8376 25.3214 55.2601 25.7469C56.1051 26.5978 56.1051 27.9958 55.2601 28.8467L39.3662 44.8525L36.288 41.7527L52.1819 25.7469C52.5843 25.3417 53.1476 25.0985 53.7311 25.0985M53.7311 21.0464C52.1417 21.0464 50.5523 21.6543 49.3451 22.8699L30.5742 41.7527L39.3461 50.5862L58.0968 31.7237C60.5111 29.2925 60.5111 25.3214 58.0968 22.8902C56.8897 21.6745 55.3003 21.0667 53.7109 21.0667L53.7311 21.0464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5742 41.7527L27.1942 51.9843C26.7717 53.2404 27.9588 54.4156 29.2061 54.0103L39.3662 50.6066L30.5943 41.773L30.5742 41.7527Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_11412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 42,
    fill: "white",
    transform: "translate(18 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.9d7e0ed06247e747312db0ad6ff6f186.svg";
export { ForwardRef as ReactComponent };